import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Drawer, DrawerContent, DrawerTitle, DrawerDescription, DrawerClose } from '@/components/ui/drawer';
import { PackageTable, PackageCards } from '@/components/pricing/RealEstatePackages';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Columns3, X } from 'lucide-react';

// "Compare packages" link on the /book package step: full table in a pop-up, answers stay put.
export const ComparePackages = ({ pick }) => {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  const choose = { ...pick, onSelect: (code) => { pick.onSelect(code); setOpen(false); } };
  const title = 'Compare packages';
  const description = 'Every package includes drone aerials and 24-hour delivery.';

  const trigger = (
    <button type="button" onClick={() => setOpen(true)} data-testid="book-compare-packages-btn"
      className="inline-flex items-center gap-2 text-sm text-[#C6A14A] hover:text-[#D4AF5A] underline-offset-4 hover:underline min-h-[44px]">
      <Columns3 className="h-4 w-4" />Compare packages
    </button>
  );

  if (isMobile) {
    return (
      <>{trigger}
        <Drawer open={open} onOpenChange={setOpen}>
          <DrawerContent overlayClassName="z-[1000]" className="z-[1001] max-h-[90dvh] bg-[#F7F5F1] border-[#C6A14A]/30" data-testid="compare-packages-sheet">
            <div className="px-4 pt-3 pb-2 flex items-start justify-between gap-3">
              <div>
                <DrawerTitle className="font-serif text-2xl text-gray-900">{title}</DrawerTitle>
                <DrawerDescription className="text-sm text-gray-500 mt-1">{description}</DrawerDescription>
              </div>
              <DrawerClose className="h-11 w-11 shrink-0 inline-flex items-center justify-center rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100" aria-label="Close" data-testid="compare-packages-close">
                <X className="h-5 w-5" />
              </DrawerClose>
            </div>
            <div className="overflow-y-auto px-4 pb-8 pt-4"><PackageCards pick={choose} idPrefix="compare" /></div>
          </DrawerContent>
        </Drawer>
      </>
    );
  }

  return (
    <>{trigger}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent overlayClassName="z-[1000]" className="z-[1001] max-w-5xl bg-[#F7F5F1] border-[#C6A14A]/30 p-6 lg:p-8 max-h-[90vh] overflow-y-auto" data-testid="compare-packages-dialog">
          <DialogTitle className="font-serif text-3xl text-gray-900">{title}</DialogTitle>
          <DialogDescription className="text-sm text-gray-500 -mt-1 mb-4">{description}</DialogDescription>
          <PackageTable pick={choose} idPrefix="compare" />
        </DialogContent>
      </Dialog>
    </>
  );
};
